<template>
  <div :class="type == 0 ? 'user-login-body':'web-login-body'">
    <div class="user-body" v-show="!loginState">
      <div class="login-box" v-show="loginTabDirector == 0">
        <div class="login-item">
          <i class="icon-login ic-user"></i>
          <input class="login-input" placeholder="输入账号" v-model="loginSubmitBean.account">
          <span v-show="accountState" class="login-error">{{accountMsg}}</span>
        </div>
        <div class="login-item">
          <i class="icon-login ic-password"></i>
          <input class="login-input" type="password" placeholder="输入密码" v-model="loginSubmitBean.password">
          <span v-show="passwordState" style="top: 130px;" class="login-error">{{passwordMsg}}</span>
        </div>
      </div>
      <div class="login-box" v-show="loginTabDirector == 1">
        <div class="login-item">
          <i class="icon-login ic-phone"></i>
          <input class="login-input" placeholder="输入手机号码" v-model="loginSubmitBean.phone">
          <span v-show="phoneState" class="login-error">{{phoneMsg}}</span>
        </div>
        <div class="login-item">
          <i class="icon-login ic-code"></i>
          <input class="login-input login-code-input" placeholder="输入验证码" v-model="loginSubmitBean.code">
          <span class="login-send-code" @click="sendCode" :class="{'loginSendCodeActive':sendCodeState}">{{codeButton}}</span>
          <span v-show="codeState" style="top: 130px;" class="login-error">{{codeMsg}}</span>
        </div>
      </div>
      <div class="login-operate">
        <input class="login-record-password" type="checkbox" v-model="loginSubmitBean.record">记住账号
        <span class="login-forget-password" @click="enterForgetPassword">忘记密码?</span>
      </div>
      <div class="login-submit" @click="loginSelect">确认登陆</div>
      <div class="login-link-body">
        <span>其他登陆方式:</span>
        <i class="icon-login icon-phone" @click="selectLoginTab(1);" v-if="loginTabDirector == 0"></i>
        <i class="icon-login icon-phone" @click="selectLoginTab(0);" v-if="loginTabDirector == 1"></i>
        <i class="icon-login ic-qq" @click="qqLogin"></i>
        <i class="icon-login ic-chat" @click="wechatLogin"></i>
        <i class="icon-login ic-ali" @click="aliLogin"></i>
      </div>
      <div class="login-register" @click="enterRegister">
        没有账号?<span>立即免费注册>></span>
      </div>
    </div>
    <div class="user-body" v-show="loginState">
      <div class="user-info">
        <img class="user-image" :src="userAvatar"/>
        <div class="user-data">
          <div class="user-name">
            <span class="user-nickname">尊敬的:{{ loginBean.user_nickname }}</span>
            <span class="user-quiet" @click='quitLogin'>[退出]</span>
          </div>
          <div class="user-value">
            <span class="user-money" title="平台币">
              <i></i>
              {{loginBean.user_money}}
            </span>
            <span class="user-level" @click="enterVip">
              <img :src="vipList[loginBean.user_vip].vsrc" :class="'vip-level-'+loginBean.user_vip"></img>
            </span>
          </div>
          <div class="user-event">
            <span class="user-center" @click="enterCenter">个人中心</span>
            <span class="user-recharge" @click="enterRecharge">充值</span>
            <span class="user-sign" :class="showSignState ? 'user-sign-active':''" @click="updateSign">{{showSignState ? '已签到':'签到'}}</span>
          </div>
        </div>
      </div>
      <span class="user-label">您玩过的游戏</span>
      <ul class="user-ul">
        <li class="user-li" v-for="(item, index) in gameHistoryList"
          :key="index" @click='enterGameSelect(item.game_device,item.game_gid,item.game_sid,item.game_out_sid,item.game_tag)'>
          <i class="user-i"></i>
          <span class="user-game">{{ item.game_name }}</span>
          <span class="user-service">{{ item.game_area_name }}</span>
          <span class="user-enter">进入游戏</span>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
  import JSEncrypt from 'jsencrypt'
  export default {
    data() {
      return {
        codeTimer:'',
        codeValue:60,
        codeButton:"发送",
        sendCodeState:false,
        loginSubmitBean: {
          account: "",
          password: "",
          record:true,
          phone:"",
          code:""
        },
        loginBean: {
          user_account: "",
          user_nickname:"",
          user_integral: 0,
          user_money:0,
          user_message: 0,
          user_vip: 0,
          vip_percentage: 0
        },
        showSignState:false,
        gameHistoryList: [],
        userAvatar:'',
        Publickey:'',
        loginTabDirector:0,
        accountState:false, //账号状态
        accountMsg:'', //账号消息
        passwordState:false, //密码状态
        passwordMsg:'', //密码消息
        phoneState:false, //手机状态
        phoneMsg:'', //手机消息
        codeState:false, //验证码状态
        codeMsg:'' //验证码消息
      };
    },
    computed:{
      baseImageAddress(){
        return this.$store.state.constant.baseImageAddress;
      },
      baseAddress(){
        return this.$store.state.constant.baseAddress;
      },
      vipList(){
        return this.$store.state.constant.vipList;
      },
      webSite(){
        return this.$store.state.home.webSite;
      },
    },
    props: {
      loginState:{
        type:Boolean,
        default:false
      },
      type:{
        type:Number,
        default:0
      }
    },
    methods: {
      quitLogin(value){
        window.sessionStorage.clear();
        window.localStorage.clear();
        this.$emit('changeLoginState', false);
      },
      enterRecharge() {
        window.open(this.$router.resolve({name: "recharge"}).href,"_blank");
      },
      enterRegister(){
        this.$emit('changeSuspendState',true);
        this.$emit('changeSuspendType',1);
      },
      sendCode(){
        if(this.loginSubmitBean.phone.length <= 0){
          alert("请输入手机号!");
          return;
        }
        if(this.sendCodeState){
          alert("验证码已发送!");
          return;
        }
        this.$http.post('/send_login_code?phone='+this.loginSubmitBean.phone,{}).then(res=>{
          if(res.data.code ==2000){    
            this.setCodeTimer();
            this.sendCodeState = true;
            alert("验证码发送成功!");
          }else{
            alert(res.data.msg);
          }
        })
      },
      //跳转个人中心
      enterCenter(){
        window.open(this.$router.resolve({name:'mineInfo'}).href,"_blank");
      },
      setCodeTimer(){
        this.codeTimer = setInterval(this.codeInterval,1000);
      },
      enterForgetPassword(){
        window.open(this.$router.resolve({name: "question",query:{index:3}}).href,'_blank');
      },
      codeInterval(){
        this.codeValue --;
        if(this.codeValue <=0){
          this.sendCodeState = false;
          this.codeButton = "发送";
          clearInterval(this.codeTimer);
        }else{
          this.codeButton = this.codeValue +"秒";
        }
      },
      updateSign(){
        if(!this.userSignState){
          this.$http.post('/update_web_mine_sign',{data:1}).then(res=>{
            if(res.data.code == 2000){
              this.loginBean.user_integral ++;
              window.sessionStorage.setItem("userIntegral",this.loginBean.user_integral);
              this.showSignState = true;
              window.sessionStorage.setItem("userSign",1);
              alert("签到成功!");
            }else{
              window.sessionStorage.setItem("userSign",0);
              this.showSignState = false;
              alert(res.data.msg);
            }
          })   
        }
      },
      loginSelect(){
        if(this.loginTabDirector == 0){
          this.loginSubmit();
        }else{
          this.loginPhoneSubmit();
        }
      },
      loginSubmit() {
        if(this.loginSubmitBean.account == "" || this.loginSubmitBean.account.length <= 1){
          this.accountState = true;
          this.accountMsg = "请输入账户!";
          return;
        }else{
          this.accountState = false;
        }
        if(this.loginSubmitBean.password == undefined || this.loginSubmitBean.password.length <= 1){
          this.passwordState = true;
          this.passwordMsg = '请输入密码!';
          return;
        }else{
          this.passwordState = false;
        }
        this.$http.post('/check_web_user',{},{
          params:{
            account:this.loginSubmitBean.account
          }
        }).then(res=>{
          let encryptor = new JSEncrypt();
          encryptor.setPublicKey(res.data.data);
          let sercetData = encryptor.encrypt(this.loginSubmitBean.password);
          this.$http.post('login_web_member', {
            data:{
              account:this.loginSubmitBean.account,
              password:sercetData
            }
          }).then(res=>{
            if (res.data.code === 2000) {
              this.loginSubmitBean.account = "";
              this.loginSubmitBean.password = "";
              window.sessionStorage.setItem("token", res.headers.token);
              this.handlerUser(res.data.data);
            } else {
              this.$emit('changeLoginState', false);
              this.accountState = true;
              this.accountMsg = res.data.msg;
            }
          });
        });     
      },
      loginPhoneSubmit(){
        if(this.loginSubmitBean.phone == "" || this.loginSubmitBean.phone.length <= 1){
          this.phoneState = true;
          this.phoneMsg = "请输入手机号!";
          return;
        }else{
          this.phoneState = false;
        }
        if(this.loginSubmitBean.code == undefined || this.loginSubmitBean.code.length <= 1){
          this.codeState = true;
          this.codeMsg = '请输入验证码!';
          return;
        }else{
          this.codeState = false;
        }
        this.$http.post('/check_web_phone',{},{
          params:{
            phone:this.loginSubmitBean.phone
          }
        }).then(res=>{
          let encryptor = new JSEncrypt();
          encryptor.setPublicKey(res.data.data);
          let sercetData = encryptor.encrypt(this.loginSubmitBean.code);
          this.$http.post('/login_web_phone', {
            data:{
              phone:this.loginSubmitBean.phone,
              code:sercetData
            }
          }).then(res=>{
            if (res.data.code === 2000) {
              this.sendCodeState = false;
              this.codeButton = "发送";
              clearInterval(this.codeTimer);
              this.loginSubmitBean.phone = "";
              this.loginSubmitBean.code = "";
              window.sessionStorage.clear();
              window.sessionStorage.setItem("token", res.headers.token);
              this.handlerUser(res.data.data);
            } else {
              this.$emit('changeLoginState', false);
              this.phoneState = true;
              this.phoneMsg = res.data.msg;
            }
          }); 
        });     
      },
      handlerUser(value){
        if(value.user_avatar !== undefined && value.user_avatar.length > 0){ 
          if(value.user_avatar.indexOf("http") === -1){
            window.sessionStorage.setItem("userAvatar",this.baseAddress+value.user_avatar); 
            this.userAvatar = this.baseAddress+value.user_avatar;
          }else{
            window.sessionStorage.setItem("userAvatar",value.user_avatar); 
            this.userAvatar = value.user_avatar;
          }
        }else{
          this.userAvatar = this.baseAddress+"img/common_default_avatar_normal.jpg";
        } 
        window.sessionStorage.setItem("userAvatar",this.userAvatar); 
        this.gameHistoryList = value.user_history;
        this.loginBean.vip_percentage = (value.user_vip_current / value.user_vip_max) * 100 +"";
        if(isNaN(this.loginBean.vip_percentage)){
          this.loginBean.vip_percentage = 0;
        }
        let userAccount = value.user_account;
        window.sessionStorage.setItem("oldUserAccount",userAccount);
        let userNickname = value.user_nickname;
        if(userNickname == undefined || userNickname.length <= 0){
          userNickname = userAccount;
        }
        this.loginBean.user_account = userAccount;
        this.loginBean.user_nickname = userNickname;
        if(value.user_integral == undefined){
          value.user_integral = 0;
        }
        this.loginBean.user_integral = value.user_integral;
        this.loginBean.user_message = value.user_message;
        this.loginBean.user_vip = value.user_vip;
        if(value.user_money == undefined){
          value.user_money = 0;
        }
        this.loginBean.user_money = value.user_money;
        window.sessionStorage.setItem("userAccount",userAccount);
        window.sessionStorage.setItem("userNickname",userNickname);
        window.sessionStorage.setItem("gameHistoryList",JSON.stringify(this.gameHistoryList));  
        window.sessionStorage.setItem("login_state",true);
        window.sessionStorage.setItem("userMessage",this.loginBean.user_message);
        window.sessionStorage.setItem("userIntegral",this.loginBean.user_integral);
        window.sessionStorage.setItem("userMoney",this.loginBean.user_money);
        window.sessionStorage.setItem("userVip", this.loginBean.user_vip);
        window.sessionStorage.setItem("vipPercentage",this.loginBean.vip_percentage); 
        window.sessionStorage.setItem("userSign",value.user_sign_state);

        let time = new Date().getTime();
        if(this.loginSubmitBean.record){
          time += 5*24*60*60*1000;
        }
        window.localStorage.setItem("token_time",time);
        window.localStorage.setItem("sessionStorage",JSON.stringify(window.sessionStorage));
        this.$emit('changeLoginState', true);
        this.$emit('changeAvatarState', true);
      },    
      queryUserInfo(){
        this.$http.post('/query_mine_center', {})
        .then(res=>{
          if(res.data.code == 2000){
            var user = res.data.data;
            this.loginBean.user_account = user.user_account;
            this.userSignCount = user.user_sign_count;
            this.userNickname = user.user_nickname;
            if(this.userNickname == undefined || this.userNickname.length <= 0){
              this.userNickname = this.userAccount;
            }
            this.loginBean.user_nickname = this.userNickname;
            this.loginBean.user_vip = user.user_vip;
            this.loginBean.user_integral = user.user_integral;
            this.loginBean.user_money = user.user_money;
            this.gameHistoryList = user.user_history;
            if(user.user_avatar != null && user.user_avatar.length > 0){ 
              if(user.user_avatar.indexOf("http") === -1){
                this.userAvatar = this.baseAddress+user.user_avatar;
              }else{
                this.userAvatar = user.user_avatar;
              }
            }else{
              this.userAvatar = this.baseAddress+"img/common_default_avatar_normal.jpg";
            }
            if(user.user_sign_state == 1){
              this.showSignState = true;
            }else{
              this.showSignState = false;
            }
          }
        })
      },
      qqLogin(){
        window.location.href =this.baseAddress+"web_qq_login?skip="+window.location.href;
      },
      wechatLogin(){
        window.location.href =this.baseAddress+"web_wechat_login?skip="+window.location.href;
      },
      aliLogin(){
        window.location.href = this.baseAddress+"web_ali_login?skip="+window.location.href;
      },
      selectLoginTab(value){
        this.loginTabDirector = value;
      },
      enterGameSelect(type,gid,sid,out_sid,tag){
        if(this.webSite.maintain_mode == 1){
          this.$emit('showMaintain',true);
        }else{
          if(type == 1){
            this.enterGameExact(gid,sid);
          }else if(type == 3){
            this.enterH5Game(gid,out_sid,tag);
          }else{
            this.enterDownload(tag);
          }
        }
      },
      enterDownload(value){
        window.open(this.$router.resolve({ name: 'transfer', query: { tag: value, type: this.GameTransfer} }).href, '_blank'); 
      },
      enterMessage(){
        window.open(this.$router.resolve({name: "mineMessage"}).href,"_blank");
      },
      enterGameExact(gid,sid){
        window.open(this.$router.resolve({name:'gameEnter', query:{gid:gid,sid:sid}}).href,'_blank');
      },
      enterH5Game(gid,out_sid,tag){
        window.open(this.$router.resolve({name:'enterH5', query:{gid:gid,sid:out_sid,path:this.$route.path,tag:tag}}).href,'_blank');
      },
      enterVip(){
        window.open(this.$router.resolve({name:'vip'}).href,"_blank");
      },
    },
    watch:{
      loginState : function(value){
        if(value){
          this.queryUserInfo();
        }
      },
    }
  };
  function hexToBytes(hex) {
    for (var bytes = [], c = 0; c < hex.length; c += 2)
      bytes.push(parseInt(hex.substr(c, 2), 16));
    return bytes; 
  }

  </script>